import { render, staticRenderFns } from "./k3.vue?vue&type=template&id=256ef6c4&scoped=true"
import script from "./k3.vue?vue&type=script&lang=js"
export * from "./k3.vue?vue&type=script&lang=js"
import style0 from "./k3.vue?vue&type=style&index=0&id=256ef6c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256ef6c4",
  null
  
)

export default component.exports